import { Box, Flex, Text, Tooltip } from '@mantine/core'
import { useTranslations } from 'next-intl'

import styles from '@/app/[locale]/price/[slug]/_components/CoinLineChart/components/CoinTitle/index.module.css'
import { SHARE_DOWNLOAD_HELPER_PORTAL_EL_ID } from '@/app/[locale]/price/[slug]/_components/CoinLineChart/components/CoinTitle/ShareModal/utils'
import { useStockContext } from '@/app/[locale]/price/stocks/[symbol]/_contexts/StockContext'
import Star from '@/assets/icons/star.svg'
import CoinIcon from '@/components/CoinIcon'
import useGlobalStore from '@/stores/global'
import { StockPrices } from '@/types/stock'
import { gotoCdcWebSignupPage } from '@/utils'

interface StockTitleProps {
  currentStockPrices?: StockPrices
  curTimeRange: string
  slug: string
  customHeader?: React.ReactNode
}

export default function StockTitle({ customHeader }: StockTitleProps) {
  const { stock } = useStockContext()
  const t = useTranslations()
  const allCoinsStatus = useGlobalStore(state => state.allCoinsStatus)
  const isLoading = allCoinsStatus === 'pending' || allCoinsStatus === undefined
  return (
    <Flex align={'center'} mb={'sm'}>
      <Box w={32} h={32} bdrs={888} bg={'var(--content-primary)'}>
        {isLoading ? <Box w={32} h={32} /> : <CoinIcon size={32} coin={stock} />}
      </Box>
      {customHeader ? (
        customHeader
      ) : (
        <>
          <Text variant={'heading2'} component="h1" mx={8}>
            {stock.name}
          </Text>
          <Text variant={'heading2'} c={'var(--content-tertiary)'} flex={1}>
            {stock.symbol}
          </Text>
        </>
      )}

      <Tooltip multiline withArrow label={t('common.addToFavorites')}>
        <Star className={styles.iconButton} onClick={gotoCdcWebSignupPage} />
      </Tooltip>

      <Box id={SHARE_DOWNLOAD_HELPER_PORTAL_EL_ID} pos={'fixed'} w={0} h={0} />
    </Flex>
  )
}
